import { useReducer } from "react"
import { servicesReducer } from "./reducer"
import { serviceInitialState } from "./data"
import { ServicesContext } from "./context";


export const ServicesProvider = ({children}: any) => {
  const [state, dispatch] = useReducer(servicesReducer, serviceInitialState);

  return (
    <ServicesContext.Provider value={{ state, dispatch}}>
      {children}
    </ServicesContext.Provider>
  )
}